import { addFilter } from '@wordpress/hooks';
import { _n, __ } from '@wordpress/i18n';

import SettingsGeneralThankyouPage from './sub-components/SettingsGeneralThankyouPage'
import SettingsCustomTripCode from './sub-components/SettingsCustomTripCode'
import SettingsEmailPoweredBy from './sub-components/SettingsEmailPoweredBy'
import SettingsEmailBookingToEmails from './sub-components/SettingsEmailBookingToEmails'
import SettingsEmailPaymentToEmails from './sub-components/SettingsEmailPaymentToEmails'
import SettingsEmailEnquiryToEmails from './sub-components/SettingsEmailEnquiryToEmails'
import SettingsCustomTabs from './sub-components/SettingsCustomTabs'
import SettingsCartCheckout from './sub-components/SettingsCartCheckout'
import SettingsFaqs from './sub-components/SettingsFaqs'
import ItineraryPdfBookingMail from './sub-components/ItineraryPdfBookingMail';
// import BookingOnePage from './sub-components/BookingOnePage';

addFilter( 'wp_travel_settings_after_general_fields', 'wp_travel', (content, ...params) => {
        return [ ...content, <SettingsGeneralThankyouPage /> ]
    }
);

addFilter( 'wp_travel_tab_content_before_trips', 'wp_travel', (content, ...params) => {
        return [ ...content, <SettingsCustomTripCode /> ]
    }
);

addFilter( 'wp_travel_tab_content_before_booking_tamplate', 'wp_travel', (content, ...params) => {
        return [ ...content, <SettingsEmailPoweredBy /> ]
    }
);

addFilter( 'wp_travel_utils_booking_notif', 'wp_travel', (content, ...params) => {
        return [ ...content, <SettingsEmailBookingToEmails /> ]
    }
);

addFilter( 'wp_travel_utils_payment_notif', 'wp_travel', (content, ...params) => {
    return [ ...content, <SettingsEmailPaymentToEmails /> ]
}
);

addFilter( 'wp_travel_utils_enquiry_notif', 'wp_travel', (content, ...params) => {
    return [ ...content, <SettingsEmailEnquiryToEmails /> ]
}
);

addFilter( 'wp_travel_custom_global_tabs', 'wp_travel', (content, ...data) => {
        return [ ...content, <SettingsCustomTabs data={data} /> ]
    }
);

addFilter( 'wp_travel_settings_tab_cart_checkout_fields', 'wp_travel', (content, ...data) => {
        return [ ...content, <SettingsCartCheckout data={data} /> ]
    }
);

addFilter( 'wp_travel_settings_tab_faq_fields', 'wp_travel', (content, ...data) => {
        return [ ...content, <SettingsFaqs data={data} /> ]
    }
);

addFilter( 'wp_travel_email_template_content_after_send_email', 'wp_travel', ( content, ...allData ) => {
    return [ ...content, <ItineraryPdfBookingMail /> ];
} );

// addFilter( 'wp_travel_single_checkout_page_for_booking', 'wp_travel', ( content, ...allData ) => {
//     return [...content, <BookingOnePage/> ];
// })
